import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://tellus-test-api.organicresponse.com',
  apiPath: '/api/v1',
  frontendUrl: 'https://tellus-test.organicresponse.com',
  elmtPollingInterval: 300000
};
